import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/app/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Movimenti from "@/pages/Movimenti";
import Ricorrenti from "@/pages/Ricorrenti";
import Prodotti from "@/pages/Prodotti";
import Vendite from "@/pages/Vendite";
import Categorie from "@/pages/Categorie";
import Utenti from "@/pages/Utenti";
import Budget from "@/pages/Budget";
import Consulente from "@/pages/Consulente";
import ConsulenteChat from "@/pages/ConsulenteChat";
import Esporta from "@/pages/Esporta";
import Profilo from "@/pages/Profilo";
import Backup from "@/pages/Backup";
import Fornitori from "@/pages/Fornitori";
import Fatture from "@/pages/Fatture";
import FatturaEditor from "@/pages/FatturaEditor";
import Uscite from "@/pages/Uscite";
import SpeseBrand from "@/pages/SpeseBrand";
import Analisi from "@/pages/Analisi";
import Magazzino from "@/pages/Magazzino";
import Marche from "@/pages/Marche";
import MagazzinoDettaglio from "@/pages/MagazzinoDettaglio";
import { Loader2 } from "lucide-react";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#8C6D62]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  return user ? <Navigate to="/dashboard" replace /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/movimenti" element={<Movimenti />} />
            <Route path="/spese-ricorrenti" element={<Ricorrenti />} />
            <Route path="/prodotti" element={<Prodotti />} />
            <Route path="/vendite-mensili" element={<Vendite />} />
            <Route path="/categorie" element={<Protected admin><Categorie /></Protected>} />
            <Route path="/utenti" element={<Protected admin><Utenti /></Protected>} />
            <Route path="/budget" element={<Protected admin><Budget /></Protected>} />
            <Route path="/consulente" element={<Protected admin><Consulente /></Protected>} />
            <Route path="/consulente/chat" element={<Protected admin><ConsulenteChat /></Protected>} />
            <Route path="/esporta" element={<Protected admin><Esporta /></Protected>} />
            <Route path="/profilo" element={<Profilo />} />
            <Route path="/backup" element={<Protected admin><Backup /></Protected>} />
            <Route path="/fornitori" element={<Fornitori />} />
            <Route path="/fatture" element={<Fatture />} />
            <Route path="/fatture/nuova" element={<FatturaEditor key="nuova" />} />
            <Route path="/fatture/:id" element={<FatturaEditor />} />
            <Route path="/uscite-merce" element={<Uscite />} />
            <Route path="/spese-brand" element={<SpeseBrand />} />
            <Route path="/marche" element={<Protected admin><Marche /></Protected>} />
            <Route path="/magazzino" element={<Magazzino />} />
            <Route path="/magazzino/:id" element={<MagazzinoDettaglio />} />
            <Route path="/analisi-margini" element={<Protected admin><Analisi /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
